import * as React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexRowCenterVertical } from '../../Defaults/Flexbox/Flexbox';
import { IconImg } from '../../Defaults/Icon/IconImg';
import { resolveCategoryUrl } from '../../../utilities/selectors';
import { DsiSvgIcon } from '../../..';
import { IconType } from '../General/SvgIcon';

enum ItemType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  TERTIARY = 'TERTIARY',
}

export interface Props {
  id: number;
  name: string;
  imgSrc: string;
  url: string;
  onClick?: any;
  onClickLink?: any;
  showArrow?: boolean;
  arrowSrc: string;
  weburl?: string | null;
  isFirstLevel?: boolean;
  isDsi?: boolean;
  icon?: IconType;
}

function MobileNavSubItem({
  name,
  imgSrc,
  url,
  weburl,
  arrowSrc,
  showArrow,
  onClickLink,
  onClick,
  id,
  isFirstLevel,
  isDsi,
  icon,
}: Props) {
  const catUrl = resolveCategoryUrl(id, url,'CATEGORYTEXT/URL');
  return (
    <Wrapper onClick={onClick}>
      <FlexRowCenterVertical>
        {!!icon && (
          <Link onClick={onClickLink} to={weburl || catUrl}>
            <DsiSvgIcon icon={icon} marginRight={8} />
          </Link>
        )}
        {!isFirstLevel && (
          <ImageWrapper to={weburl || catUrl}>
            <Image src={imgSrc} />
          </ImageWrapper>
        )}
        <NameLink
          isFirstLevel={isFirstLevel}
          isDsi={isDsi}
          onClick={onClickLink}
          to={weburl || catUrl}
        >
          {name}
        </NameLink>
      </FlexRowCenterVertical>
      {showArrow && (
        <IconImg
          cursor="pointer"
          width={16}
          height={16}
          src={arrowSrc}
          alt="right-icon"
          padding={8}
        />
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  text-decoration: none;
  padding: ${rem(16)};
  color: ${({ theme }) => theme.colors.textPrimary};
  background-color: ${({ theme }) => theme.colors.white};
  line-height: ${rem(18)};
  font-size: 14px;
  border-top: ${({ theme }) => theme.borders.primary};

  display: flex;
  align-items: center;
  position: relative;
  justify-content: space-between;

  &:nth-child(2) {
    border-top: ${({ theme }) => theme.borders.primary};
  }
`;

const NameLink = styled(Link)<{ isFirstLevel?: boolean; isDsi?: boolean }>`
  color: ${({ theme }) => theme.colors.textPrimary};
  font-weight: ${({ isFirstLevel }) => (isFirstLevel ? 500 : 400)};
  text-decoration: none;
  font-size: ${({ isDsi }) => (isDsi ? rem(16) : rem(14))};
`;

const ImageWrapper = styled(Link)`
  display: flex;
  flex-flow: row;
  justify-content: center;
  align-items: center;
  width: ${rem(24)};
  height: ${rem(24)};
  margin-right: ${rem(16)};
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
`;

export { MobileNavSubItem };
